// extracted by mini-css-extract-plugin
export default {"root":"classes_root__oQDdM","content":"classes_content__em7VR","cross":"classes_cross__5vijl"};